import ChartData, { ChartPoint, IChartData } from '../domain/chartData';
import ChartDataRepository from '../infractructure/repositories/chartDataRepository';
import IChartDataRepository from '../infractructure/repositories/IChartDataRepository';

interface IQueryParams {
  start_date_hour_range: string; // 'yyyy-MM-dd HH:mm'
  end_date_hour_range: string; // 'yyyy-MM-dd HH:mm'
  unloading_type: 'packages' | 'trucks';
  workshop_type: string;
  interval: string;
  booked: number;
  start_minute_offset?: number;
  workshop_query?: string;
}

class GetChartDataUseCase {
  private readonly _repository: IChartDataRepository;

  constructor({ repository }) {
    this._repository = repository;
  }

  execute({
    queryParams,
    filterBy
  }: {
    queryParams: IQueryParams;
    filterBy?: ChartPoint[];
  }): Promise<{
    filterdData?: IChartData;
    chartData: IChartData;
  }> {
    const { start_date_hour_range, end_date_hour_range, interval } =
      queryParams;

    const rangeStart = ChartData.parseUtcDate(start_date_hour_range);
    const rangeEnd = ChartData.parseUtcDate(end_date_hour_range);

    const slotDurationMinutes =
      interval === '1h' ? 60 : Number.parseInt(interval, 10);

    return this._repository.getChartData({ queryParams }).then((res) => {
      const chartData = ChartData.generateFromDTO(
        res,
        rangeStart,
        rangeEnd,
        slotDurationMinutes
      );
      return filterBy?.length
        ? {
            filterdData: chartData.filterByPoints(filterBy),
            chartData: chartData
          }
        : { chartData };
    });
  }
}

export default new GetChartDataUseCase({
  repository: ChartDataRepository
});
